import { ClpStatementsComponent } from './clp-statements.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ ClpStatementsComponent });
